import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import footerLogo from '@/assets/img/footer_logo.png';

export const Footer: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleProductClick = (e: React.MouseEvent<HTMLAnchorElement>, hash: string) => {
    e.preventDefault();
    
    // If we're not on the home page, navigate there first
    if (location.pathname !== '/') {
      navigate('/' + hash);
    } else {
      // We're already on the home page, just update the hash
      window.location.hash = hash;

      // Scroll to section
      const element = document.querySelector(hash.startsWith('#lineup') ? '#lineup' : hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const scrollToTop = (e: React.MouseEvent) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-brand">
              <h3>WiCanvas</h3>
              <p>次世代ワイヤレスディスプレイソリューション</p>
            </div>
            <div className="footer-links">
              <div className="footer-column">
                <h4>製品</h4>
                <ul>
                  <li><a href="/#lineup-indoor" onClick={(e) => handleProductClick(e, '#lineup-indoor')}>Indoor シリーズ</a></li>
                  <li><a href="/#lineup-outdoor" onClick={(e) => handleProductClick(e, '#lineup-outdoor')}>Outdoor シリーズ</a></li>
                  <li><a href="/#lineup-square" onClick={(e) => handleProductClick(e, '#lineup-square')}>Square シリーズ</a></li>
                  <li><a href="/#lineup-accessories" onClick={(e) => handleProductClick(e, '#lineup-accessories')}>アクセサリー</a></li>
                </ul>
              </div>
              <div className="footer-column">
                <h4>機能</h4>
                <ul>
                  <li><Link to="/cms-features">CMS機能</Link></li>
                  <li><a href="/#features" onClick={(e) => handleProductClick(e, '#features')}>主要特長</a></li>
                </ul>
              </div>
              <div className="footer-column">
                <h4>サポート</h4>
                <ul>
                  <li><a href="/#contact" onClick={(e) => handleProductClick(e, '#contact')}>お問い合わせ</a></li>
                  <li><Link to="/download-guide">ダウンロード</Link></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* JATO共通フッター (footer.jpgを参考) */}
      <div className="jato-common-footer">
        <div className="container">
          <div className="jato-footer-inner">
            <div className="jato-footer-left">
              <a href="https://www.jato.co.jp/" target="_blank" rel="noopener noreferrer">
                <img src={footerLogo} alt="JATO ジャトー株式会社" className="jato-footer-logo" />
              </a>
            </div>
            <div className="jato-footer-right">
              <p className="jato-copyright">(c) Copyright JATO Co.,Ltd. All right reserved.</p>
              <a href="#" className="jato-page-top" onClick={scrollToTop}>
                <span className="arrow">▲</span> PAGE TOP
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
